









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { translationSvc } from '@/services';
import { Translation } from '@/types';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSave } from '@fortawesome/pro-light-svg-icons';

library.add(faSave);

@Component({
  name: 'translation-item'
})
export default class Translations extends Vue {
  @Prop()
  locale!: string;

  @Prop()
  translationKey!: string;

  @Prop()
  value!: string;

  @Prop()
  id!: string;

  isLoading: boolean = false;
  input: string = '';

  mounted() {
    this.input = this.value;
  }

  async saveTranslation() {
    const value = this.input;
    this.isLoading = true;
    const splitKey = this.translationKey.split(':');
    let namespace = splitKey[0];
    let group = splitKey[1];
    let translationKey = splitKey[2];
    try {
      const translation = await translationSvc.upsertTranslation({
        id: parseInt(this.id),
        namespace: splitKey[0],
        group: splitKey[1],
        key: splitKey[2],
        value,
        locale: this.locale
      });
      this.$emit('translationSaved', translation);
    } catch (e) {
      // intentionally left blank
    }
    this.isLoading = false;
  }
}
